import { motion } from "framer-motion";

const ALBUM_COVER_2 = "https://customer-assets.emergentagent.com/job_preludium-experience/artifacts/dqu2xvrj_Preludium%20album%20ok%C5%82adka.jpg";
const ARTIST_PHOTO = "https://customer-assets.emergentagent.com/job_preludium-experience/artifacts/h2ye7vs3_image.png";

const galleryItems = [
  { src: "/images/koncert/koncert1.jpg", alt: "Pueblo — koncert", span: "col-span-2 row-span-2" },
  { src: "/images/teledysk/new1.png", alt: "Pueblo — blue light", span: "col-span-1 row-span-1" },
  { src: "/images/teledysk/new3.jpg", alt: "Pueblo — backstage", span: "col-span-1 row-span-2" },
  { src: "/images/teledysk/new2.jpg", alt: "Pueblo — mirror", span: "col-span-1 row-span-1" },
  { src: ARTIST_PHOTO, alt: "Pueblo — spotlight", span: "col-span-1 row-span-2" },
  { src: "/images/teledysk/new4.jpg", alt: "Pueblo — one", span: "col-span-1 row-span-1" },
  { src: ALBUM_COVER_2, alt: "Preludium — okładka", span: "col-span-1 row-span-1" },
  { src: "/images/teledysk/teledysk11.jpg", alt: "Pueblo — wizja", span: "col-span-2 row-span-1" },
  { src: "/images/koncert/koncert2.jpg", alt: "Pueblo — scena", span: "col-span-1 row-span-1" },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="font-['Oswald'] text-3xl md:text-4xl font-bold uppercase tracking-tighter mb-2"
            data-testid="gallery-section-title"
          >
            Galeria
          </h2>
          <div className="w-16 h-[2px] bg-[#EB0023] mb-10" />
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 auto-rows-[200px] md:auto-rows-[280px] gap-2 md:gap-3">
          {galleryItems.map((item, idx) => (
            <motion.div
              key={idx}
              data-testid={`gallery-item-${idx}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              className={`gallery-item overflow-hidden relative cursor-pointer ${item.span}`}
            >
              <img
                src={item.src}
                alt={item.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="font-['Oswald'] text-sm uppercase tracking-wider">
                  {item.alt}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
